import { is } from 'immutable'
import React from 'react'
import ChatBubble from './chatBubble'
import { getAnnouncementImageURL, getAnnouncementName } from './menu/announcements'
import PlayerClock from './playerClock'

/**
 * @param outline: ImmutableJS
 * @param table: ImmutableJS
 * @param active: Boolean
 * @param position: left | top | right | self
 */
class Player extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            animateAnnouncement: false
        }
    }

    componentDidUpdate(prevProps)
    {
        const party = this.props.outline ? this.props.outline.get("party") : null
        const animateAnnouncement = this.props.table && prevProps.table
            && this.props.table.getIn([ "partyAnnouncements", party ]) !== prevProps.table.getIn([ "partyAnnouncements", party ])
        if (animateAnnouncement && !this.state.animateAnnouncement) {
            this.setState({ animateAnnouncement: true })
        }
    }

    render()
    {
        const table = this.props.table
        const player = this.props.outline
        const isSelf = player && this.props.table.get("ownId") === player.get("id")

        let playerNameFontSizes = Object.entries({
            0: undefined,
            14: 20,
            16: 17
        }).sort((a, b) => b[0] - a[0])

        const playerName = player ? (
            <div 
                className={ "player-name " + (player.get("name").length >= 25 ? "long-name" : "") }
                style={{ fontSize: playerNameFontSizes.filter(e => player.get("name").length >= e[0])[0][1] }}>
                { player.get("name") }
            </div>
        ) : (
            <div className={ "player-name" }>
                { table.get("players").size >= 4 ? Messages("table.player.left-table") : Messages("table.player.free-slot") }
            </div>
        )

        const playerTitle = player ? (
            <div className="player-title">
                { ("#" + (player.get("idx") + 1)
                    + (isSelf ? (" • " + Messages("table.player.self")) : "")
                    + (player.get("announcement") ? (" • " + getAnnouncementName(player.get("announcement"), player.get("party"), true)) : "")
                    + (this.props.active ? (" • " + Messages("table.player.active")) : "")).toUpperCase() }
            </div>  
        ) : null;

        let stats = null
        let statusMessage = null
        let startHero = null
        let announcement = null

        if (player) {
            if (table.get("status") === "HEALTH") {
                stats = (
                    <div className="player-stats" style={{ justifyContent: "center" }}>
                        { Messages("game.bid." + player.get("bid").toLowerCase().replace(/_/g, "-")) }
                    </div>
                )
            } else {
                let party = null

                if (player.get("party") && ![ "NONE", "UNKNOWN" ].includes(player.get("party"))) {
                    let partyName = Messages("table.player.party." + player.get("party").toLowerCase().replace(/_/g, "-"))
                    if (isSelf && !this.props.table.get("isOwnPartyKnown")) {
                        partyName = "(" + partyName + ")";
                    }
                    party = (
                        <div className="item">
                            <div>{ partyName }</div>
                        </div>
                    )
                }

                let cardCount = table.get("status") === "ACTIVE" ? (
                    <div className="item">
                        <img src="/assets/images/cards.png" />
                        <div>{ player.get("cardCount") }</div>
                    </div>
                ) : null

                let cardPointsSum = [ "END_OF_ROUND", "FINISHED" ].includes(table.get("status")) ? (
                    <div className="item">
                        <img src="/assets/images/cards_sum.png" />
                        <div>{ table.getIn([ "latestRoundResult", "playerCardPoints", player.get("id") ]) }</div>
                    </div>
                ) : null

                stats = (
                    <div className="player-stats">
                        { party }
                        { cardCount }
                        { cardPointsSum }
                        <div className="item">
                            <img src="/assets/images/tricks.png" />
                            <div>{ player.get("trickCount") }</div>
                        </div>
                        <div className="item">
                            <img src="/assets/images/sum.png" />
                            <div>{ table.getIn([ "latestRoundResult", "playerTotalPoints", player.get("id") ]) || 0 }</div>
                        </div>
                    </div>
                )

                const isPlayingSolo = player.get("party") === "RE" && table.get("players")
                    .every(p => (p.get("id") == player.get("id")) || p.get("party") === "KONTRA")

                if (player.get("bid").startsWith("MARRIAGE"))
                {
                    if (isPlayingSolo)
                    {
                        statusMessage = Messages("table.player.marriage.unmarried")
                    }
                    else if (table.get("players").filter(p => p.get("party") == "RE").size == 1
                        && table.get("marriageDecision") !== "NOT_APPLICABLE")
                    {
                        const turnsLeftBeforeSolo = 3 - table.get("players").map(p => p.get("trickCount")).reduce((sum, v) => v + sum, 0)
                        const which = table.get("players").some(p => p.get("id") !== player.get("id") && p.get("trickCount") > 0) ? "next"
                            : (player.get("bid") == "MARRIAGE_FIRST" ? "next" : "after-next") 
                        statusMessage = Messages("table.player.marriage." + which, turnsLeftBeforeSolo)
                    }
                }
                else if (isPlayingSolo)
                {
                    statusMessage = Messages("game.bid." + table.get("gameMode").toLowerCase().replace(/_/g, "-"))
                }
                else if (player.get("bid") == "POVERTY" && table.get("status") === "POVERTY")
                {
                    statusMessage = Messages("game.bid.poverty")
                }

                if (player.get("lastDisconnected"))
                {
                    statusMessage = statusMessage ? (Messages("table.disconnected") + " (" + statusMessage + ")") : Messages("table.disconnected")
                }
            }

            announcement = player ? table.getIn([ "partyAnnouncements", player.get("party") ]) : null

            if (table.get("status") === "ACTIVE" && announcement) {
                startHero = (
                    <img
                        key={ announcement }
                        className={ "start-hero " + (this.state.animateAnnouncement ? "animated" : "") }
                        src={ getAnnouncementImageURL(announcement, player.get("party")) }
                    />
                )
            } else if ([ "END_OF_ROUND", "FINISHED" ].includes(table.get("status"))) {
                const pointsEarned = table.getIn([ "latestRoundResult", "playerTotalPoints", player.get("id") ]) - (table.getIn([ "latestRoundResult", "playerPreviousTotalPoints", player.get("id") ]) || 0)
                startHero = (
                    <div key="pts" className="start-hero animated">{ pointsEarned >= 0 ? ("+" + pointsEarned) : pointsEarned }</div>
                )
            }
        }

        statusMessage = (statusMessage && ![ "END_OF_ROUND", "FINISHED", "WAITING_FOR_PLAYERS" ].includes(table.get("status"))) ? (
            <div className="player-status-message">{ statusMessage }</div>
        ) : null;

        let spectatorBadge = player && (table.get("spectatingId") === player.get("id")) ? (
            <div className="spectator-badge">
                <div></div>
                <div>{ Messages("table.spectate.live").toUpperCase() }</div>
            </div>
        ) : null

        let playerClock = player ? (
            <PlayerClock
                timeRemaining={ player.get("timeRemaining") }
                onTurnSince={ table.get("status") == "ACTIVE" ? player.get("onTurnSince") : null }
                timeLimit={ table.get("timeLimit") }
            />
        ) : null

        return (
            <div style={ this.props.style } className={ "game-player " + (startHero ? "large " : "") + (this.props.className || "") }>
                <div className={ "upper " + (player ? player.get("color").toLowerCase() : "") }>
                    { startHero }
                    <div className={ "player-info" }>
                        { playerTitle }
                        { playerName }
                    </div>
                </div>
                { spectatorBadge }
                { playerClock }
                { stats }
                { statusMessage }
                <ChatBubble
                    players={ [ player ] }
                    className={ this.props.position }
                />
            </div>
        )
    }

}

export default Player
export { Player }